import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { AxiosInstance } from "axios";

let notificationTypesApiPromise: Promise<AxiosInstance> | null = null;

const getNotificationTypesApi = async (): Promise<AxiosInstance | null> => {
  if (notificationTypesApiPromise !== null) return notificationTypesApiPromise;
  notificationTypesApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return notificationTypesApiPromise;
};

const BASE_PATH = "/TiposNotificacion";

export interface NotificationTypeListItem {
  id: number;
  entidad: string;
  estado: string;
  titulo: string;
  esCritica: boolean;
  codigo: string;
  modulo: string;
}

export interface NotificationTypeDetail {
  id: number;
  idEstado: number | null;
  idEntidad: number | null;
  modulo: string;
  titulo: string;
  cuerpo: string;
  tieneIdentificador: boolean;
  cantidadParametros: number;
  indicesParametros: number[];
  formatoIdentificador: string;
}

export interface PatchNotificationTypeData {
  titulo: string;
  cuerpo: string;
  tieneIdentificador: boolean;
  cantidadParametros: number;
}

export interface PatchNotificationTypeBody {
  id: number;
  data: PatchNotificationTypeData;
}

export const getNotificationTypes = async (): Promise<
  NotificationTypeListItem[] | null
> => {
  const api = await getNotificationTypesApi();
  if (!api) return null;

  const response = await api.get(BASE_PATH);
  return response.data;
};

export interface GetNotificationTypeDetailProps {
  id: number;
}

export const getNotificationTypeDetail = async (
  props: GetNotificationTypeDetailProps,
): Promise<NotificationTypeDetail | null> => {
  const api = await getNotificationTypesApi();
  if (!api) return null;

  const response = await api.get(`${BASE_PATH}/${props.id}`);
  return response.data;
};

export const patchNotificationType = async (
  id: number,
  data: PatchNotificationTypeData,
) => {
  const api = await getNotificationTypesApi();
  if (!api) return null;

  const body: PatchNotificationTypeBody = {
    id,
    data,
  };

  const response = await api.patch(`${BASE_PATH}/${id}`, body);
  return response.data;
};

